import type { ReactElement, KeyboardEvent } from 'react'
import { Row, Radio, TextGroup, Title, Description } from './MethodCard.styles'

interface MethodCardProps {
  title: string
  description: string
  isSelected: boolean
  onClick: () => void
}

export function MethodCard({
  title,
  description,
  isSelected,
  onClick,
}: MethodCardProps): ReactElement {
  const handleKeyDown = (e: KeyboardEvent): void => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onClick()
    }
  }

  return (
    <Row
      $selected={isSelected}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="radio"
      tabIndex={0}
      aria-checked={isSelected}
    >
      <Radio $selected={isSelected} />
      <TextGroup>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </TextGroup>
    </Row>
  )
}
